import { Box, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

type FormulaContainerProps = { children: React.ReactNode };
export const FormulaContainer = ({ children }: FormulaContainerProps) => {
  const backgroundColor = useColorModeValue('gray.50', 'gray.900');
  const color = useColorModeValue('gray.950', 'white');
  return (
    <Box
      fontSize="sm"
      padding="16px"
      backgroundColor={backgroundColor}
      color={color}
      borderRadius="8px"
      wordBreak="break-all"
    >
      {children}
    </Box>
  );
};
